import classNames from "classnames";

const GridCardSkeleton = ({ className }: { className?: string }) => {
  return (
    <div
      className={classNames(
        "rounded-8 border bg-fds-primary border-fds-cart hover:shadow-brand-md flex flex-col p-2  md:p-3",
        className
      )}
    >
      <div className="relative aspect-video w-full mb-1 sm:mb-2">
        <div className="absolute inset-0 bg-fds-secondary rounded-6" />
      </div>

      <div className="sm:min-h-12 min-h-10 md:mb-1.5  mb-1">
        <div className="h-5    w-full bg-fds-secondary mb-px" />
        <div className="h-5    w-1/2 bg-fds-secondary mt-0.5" />
      </div>

      <div className="h-5 mb-1 sm:mb-1.5" />

      <div className="flex-col flex">
        <div className="flex md:gap-1.5  gap-1 ">
          <div className="h-4 w-4 bg-fds-secondary rounded" />
          <div className="h-4     w-20 bg-fds-secondary" />
        </div>
        <div className="flex gap-1.5 mt-1 md:mt-1.5 text-fds-secondary ">
          <div className="h-4 w-4 bg-fds-secondary rounded" />
          <div className="h-4     w-20 bg-fds-secondary" />
        </div>
      </div>

      <div className="w-full pt-2.5  ">
        <div className="flex justify-between w-full items-center h-fds-34 sm:h-9">
          <div className="flex-col-reverse flex justify-between w-full grow ">
            <div className="flex items-center gap-1.5">
              <div className="md:title-lg title-md-demibold text-fds-primary h-6  w-fds-120 bg-fds-secondary" />
            </div>
          </div>
          <div className="p-2.5   bg-transparent rounded-8">
            <div className="md:h-6 md:w-6 h-5 w-5 bg-fds-secondary rounded-8" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GridCardSkeleton;
